import React, { Component } from "react";
export default class LanguageNamingSection extends Component {
  render() {
    var {
      picture_name_1,
      picture_status_1,
      picture_name_2,
      picture_status_2,
      picture_name_3,
      picture_status_3,
      picture_name_4,
      picture_status_4,
      picture_name_5,
      picture_status_5,
      picture_name_6,
      picture_status_6,
      picture_name_7,
      picture_status_7,
      picture_name_8,
      picture_status_8,
      written_picture_score,
    } = this.props.data;
    return (
      <div className="row p-0 border border-dark">
        <div className="col-lg-12 p-3">
          <span className="fs-19">
            <ul style={{ paddingLeft: 20 }}>
              <li style={{ listStyle: "square" }}>
                Administration:
                <ul style={{ paddingLeft: 40 }}>
                  <li style={{ listStyle: "circle" }}>
                    There are eight pictures displayed. Participants will name
                    the objects shown. No time limit is enforced for the task.
                    Incorrect answers are recorded and no prompt for alternative
                    word is provided. Self-corrections are allowed; only the
                    final answer is taken for scoring.
                  </li>
                </ul>
              </li>
              <li style={{ listStyle: "square" }}>
                Scoring
                <ul style={{ paddingLeft: 40 }}>
                  <li style={{ listStyle: "circle" }}>
                    A correct score will only be given if the exact name is said
                    or spelled correctly.
                  </li>
                  <li style={{ listStyle: "circle" }}>
                    Self-corrections are allowed; only the final answer is taken
                    for scoring.
                  </li>
                </ul>
              </li>
              <li style={{ listStyle: "square" }}>
                Say:
                <ul style={{ paddingLeft: 40 }}>
                  <li style={{ listStyle: "circle" }}>
                    There is no time limit. Can you name the objects shown
                    below, from top to bottom?
                  </li>
                </ul>
                <br />
                <div className="row" style={{ fontSize: 15 }}>
                  <div className="col-lg-6 d-flex">
                    <div className="flex-wrap picture-div d-flex align-items-center">
                      <p
                        style={{
                          fontSize: 17,
                          position: "relative",
                          top: -50,
                        }}
                      >
                        1)
                      </p>
                      <img
                        className="form-picture"
                        src={require("../../../../../../assets/img/ecas-form/scorpion.png")}
                        alt="scorpion"
                        style={{ width: 190 }}
                      />
                      <div style={{ marginLeft: 7 }}>
                        <input
                          style={{ width: 180 }}
                          name="picture_name_1"
                          value={picture_name_1}
                          type="text"
                          placeholder="Picture name"
                          className="ecas-input-field"
                        />
                        <input
                          type="checkbox"
                          name="picture_status_1"
                          style={{ width: 30 }}
                          checked={picture_status_1 == "1" ? true : false}
                        />
                        <p className="correct-answer-p">
                          <span className="font-weight-bold">
                            Correct Answer:
                          </span>{" "}
                          Scorpion
                        </p>
                      </div>
                    </div>
                    <br />
                  </div>
                  <div className="col-lg-6 d-flex align-items-baseline">
                    <div className="flex-wrap picture-div d-flex align-items-center">
                      <p
                        style={{
                          fontSize: 17,
                          position: "relative",
                          top: -50,
                        }}
                      >
                        2)
                      </p>
                      <img
                        className="form-picture"
                        src={require("../../../../../../assets/img/ecas-form/coller.png")}
                        alt="scorpion"
                        style={{ width: 190 }}
                      />
                      <div style={{ marginLeft: 7 }}>
                        <input
                          style={{ width: 180 }}
                          name="picture_name_2"
                          type="text"
                          placeholder="Picture name"
                          className="ecas-input-field"
                          value={picture_name_2}
                        />
                        <input
                          type="checkbox"
                          defaultChecked={picture_status_2}
                          name="picture_status_2"
                          style={{ width: 30 }}
                          checked={picture_status_2 == "1" ? true : false}
                        />
                        <p className="correct-answer-p">
                          <span className="font-weight-bold">
                            Correct Answer:
                          </span>{" "}
                          Bow
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex align-items-baseline">
                    <div className="flex-wrap picture-div d-flex align-items-center">
                      <p
                        style={{
                          fontSize: 17,
                          position: "relative",
                          top: -50,
                        }}
                      >
                        3)
                      </p>
                      <img
                        className="form-picture"
                        src={require("../../../../../../assets/img/ecas-form/helicopter.png")}
                        alt="scorpion"
                        style={{ width: 190 }}
                      />
                      <div style={{ marginLeft: 7 }}>
                        <input
                          style={{ width: 180 }}
                          name="picture_name_3"
                          type="text"
                          placeholder="Picture name"
                          className="ecas-input-field"
                          value={picture_name_3}
                        />
                        <input
                          type="checkbox"
                          defaultChecked={picture_status_3}
                          name="picture_status_3"
                          style={{ width: 30 }}
                          checked={picture_status_3 == "1" ? true : false}
                        />
                        <p className="correct-answer-p">
                          <span className="font-weight-bold">
                            Correct Answer:
                          </span>{" "}
                          Helicopter
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex align-items-baseline">
                    <div className="flex-wrap picture-div d-flex align-items-center">
                      <p
                        style={{
                          fontSize: 17,
                          position: "relative",
                          top: -50,
                        }}
                      >
                        4)
                      </p>
                      <img
                        className="form-picture"
                        src={require("../../../../../../assets/img/ecas-form/fox.png")}
                        alt="scorpion"
                        style={{ width: 190 }}
                      />
                      <div style={{ marginLeft: 7 }}>
                        <input
                          style={{ width: 180 }}
                          name="picture_name_4"
                          type="text"
                          placeholder="Picture name"
                          className="ecas-input-field"
                          value={picture_name_4}
                        />
                        <input
                          type="checkbox"
                          defaultChecked={picture_status_4}
                          checked={picture_status_4 == "1" ? true : false}
                          name="picture_status_4"
                          style={{ width: 30 }}
                        />
                        <p className="correct-answer-p">
                          <span className="font-weight-bold">
                            Correct Answer:
                          </span>{" "}
                          Fox
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex align-items-baseline">
                    <div className="flex-wrap picture-div d-flex align-items-center">
                      <p
                        style={{
                          fontSize: 17,
                          position: "relative",
                          top: -50,
                        }}
                      >
                        5)
                      </p>
                      <img
                        className="form-picture"
                        src={require("../../../../../../assets/img/ecas-form/rod.png")}
                        alt="scorpion"
                        style={{ width: 190 }}
                      />
                      <div style={{ marginLeft: 7 }}>
                        <input
                          style={{ width: 180 }}
                          name="picture_name_5"
                          type="text"
                          placeholder="Picture name"
                          className="ecas-input-field"
                          value={picture_name_5}
                        />
                        <input
                          type="checkbox"
                          defaultChecked={picture_status_5}
                          checked={picture_status_5 == "1" ? true : false}
                          name="picture_status_5"
                          style={{ width: 30 }}
                        />
                        <p className="correct-answer-p">
                          <span className="font-weight-bold">
                            Correct Answer:
                          </span>{" "}
                          Axe
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex align-items-baseline">
                    <div className="flex-wrap picture-div d-flex align-items-center">
                      <p
                        style={{
                          fontSize: 17,
                          position: "relative",
                          top: -50,
                        }}
                      >
                        6)
                      </p>
                      <img
                        className="form-picture"
                        src={require("../../../../../../assets/img/ecas-form/rabbit.png")}
                        alt="scorpion"
                        style={{ width: 190 }}
                      />
                      <div style={{ marginLeft: 7 }}>
                        <input
                          style={{ width: 180 }}
                          name="picture_name_6"
                          type="text"
                          placeholder="Picture name"
                          className="ecas-input-field"
                          value={picture_name_6}
                        />
                        <input
                          type="checkbox"
                          defaultChecked={picture_status_6}
                          name="picture_status_6"
                          style={{ width: 30 }}
                          checked={picture_status_6 == "1" ? true : false}
                        />
                        <p className="correct-answer-p">
                          <span className="font-weight-bold">
                            Correct Answer:
                          </span>{" "}
                          Squirrel
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex align-items-baseline">
                    <div className="flex-wrap picture-div d-flex align-items-center">
                      <p
                        style={{
                          fontSize: 17,
                          position: "relative",
                          top: -50,
                        }}
                      >
                        7)
                      </p>
                      <img
                        className="form-picture"
                        src={require("../../../../../../assets/img/ecas-form/duck.png")}
                        alt="scorpion"
                        style={{ width: 190 }}
                      />
                      <div style={{ marginLeft: 7 }}>
                        <input
                          style={{ width: 180 }}
                          name="picture_name_7"
                          type="text"
                          placeholder="Picture name"
                          className="ecas-input-field"
                          value={picture_name_7}
                        />
                        <input
                          type="checkbox"
                          defaultChecked={picture_status_7}
                          name="picture_status_7"
                          style={{ width: 30 }}
                          checked={picture_status_7 == "1" ? true : false}
                        />
                        <p className="correct-answer-p">
                          <span className="font-weight-bold">
                            Correct Answer:
                          </span>{" "}
                          Swan
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex align-items-baseline">
                    <div className="flex-wrap picture-div d-flex align-items-center">
                      <p
                        style={{
                          fontSize: 17,
                          position: "relative",
                          top: -50,
                        }}
                      >
                        8)
                      </p>
                      <img
                        className="form-picture"
                        src={require("../../../../../../assets/img/ecas-form/music-tool.png")}
                        alt="scorpion"
                        style={{ width: 190 }}
                      />
                      <div style={{ marginLeft: 7 }}>
                        <input
                          style={{ width: 180 }}
                          name="picture_name_8"
                          value={picture_name_8}
                          type="text"
                          placeholder="Picture name"
                          className="ecas-input-field"
                        />
                        <input
                          type="checkbox"
                          defaultChecked={picture_status_8}
                          name="picture_status_8"
                          style={{ width: 30 }}
                          checked={picture_status_8 == "1" ? true : false}
                        />
                        <p className="correct-answer-p">
                          <span className="font-weight-bold">
                            Correct Answer:
                          </span>{" "}
                          Accordion
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </span>
          <hr />
          <div className="col-lg-6">
            <span className="fs-19">Score (0-8) </span>
            <input
              type="number"
              value={written_picture_score}
              name="written_picture_score"
              readOnly
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
